<div class="tiptap-editor">
  <div #editorContainer class="editor-content"></div>

  <!-- This div is targeted by BubbleMenu extension -->
  <div class="formatting-bubble-menu bubble-menu-container">
    <ion-button fill="clear" class="btn-small btn-formatting" (click)="insertEmoji($event)" title="Emoji">
      <ion-icon name="happy-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBold()"
      [class.is-active]="editor?.isActive('bold')"
      title="Bold"
    >
      <ion-icon name="custom-bold"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleItalic()"
      [class.is-active]="editor?.isActive('italic')"
      title="Italic"
    >
      <ion-icon name="custom-italic"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBulletList()"
      [class.is-active]="editor?.isActive('bulletList')"
      title="Bulleted list"
    >
      <ion-icon name="custom-unordered-list"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleOrderedList()"
      [class.is-active]="editor?.isActive('orderedList')"
      title="Ordered list"
    >
      <ion-icon name="custom-ordered-list"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleBlockquote()"
      [class.is-active]="editor?.isActive('blockquote')"
      title="Block quote"
    >
      <ion-icon name="custom-blockquote"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleCode()"
      [class.is-active]="editor?.isActive('code')"
      title="Code"
    >
      <ion-icon name="custom-code-view"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="toggleCodeBlock()"
      [class.is-active]="editor?.isActive('codeBlock')"
      title="Code block"
    >
      <ion-icon name="custom-code-block"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      class="btn-small btn-formatting"
      (click)="addLink()"
      [class.is-active]="editor?.isActive('link')"
      title="Add link"
    >
      <ion-icon name="custom-link"></ion-icon>
    </ion-button>
    <ion-button fill="clear" class="btn-small btn-formatting" (click)="clearFormatting()" title="Clear format">
      <ion-icon name="custom-format-clear"></ion-icon>
    </ion-button>
  </div>

  <!-- Link Context Bubble Menu -->
  <div class="link-context-menu bubble-menu-container">
    <ion-button fill="clear" class="btn-small btn-formatting" (click)="editLink()" title="Edit Link">
      <ion-icon name="pencil-outline"></ion-icon> Edit
    </ion-button>
    <ion-button fill="clear" class="btn-small btn-formatting" (click)="unsetLink()" title="Remove Link">
      <ion-icon name="trash-bin-outline"></ion-icon> Remove
    </ion-button>
    <ion-button fill="clear" class="btn-small btn-formatting" (click)="openLink()" title="Open Link">
      <ion-icon name="open-outline"></ion-icon> Open
    </ion-button>
  </div>
</div>
